<div class="w-full grid grid-cols-[1fr_auto] gap-1 items-center">
  <div>
    <label [attr.for]="for" [attr.class]="class">
      <ng-content></ng-content>
    </label>
  </div>
  @if (editMode) {
    <div></div>
  } @else {
    <div class="text-right">
      @if (iconVisible) {
        <button
          class="hover:bg-gray-100 hover:scale-120 cursor-pointer rounded-md"
          [ngClass]="iconColor"
          type="button"
          (click)="toggleHelp()"
          appAgentAction
          agent="label-with-help-toggle"
          action="toggle"
        >
          <app-help-open-icon [isOpen]="helpVisible"></app-help-open-icon>
        </button>
      }
    </div>
  }
  @if (helpVisible) {
    <div class="col-span-full flex justify-between" animate.enter="help-enter" animate.leave="help-leave">
      <div class="text-xs font-thin whitespace-pre-line mb-2 ms-1">
        @if (!helpText || helpText === '') {
          <span class="text-gray-400 italic">No help text available yet.</span>
        } @else {
          {{ helpText }}
        }
      </div>
      <div class="text-right justify-self-end">
        @if (canEdit) {
          <button
            class="hover:bg-gray-100 hover:scale-120 cursor-pointer rounded-md"
            [ngClass]="iconColor"
            type="button"
            (click)="startEditing()"
            appAgentAction
            agent="label-with-help-edit"
            action="edit"
          >
            <app-edit [size]="5"></app-edit>
          </button>
        }
      </div>
    </div>
  }
  @if (editMode) {
    <div>
      <textarea
        [(ngModel)]="updatedHelpText"
        [maxlength]="1000"
        class="w-[calc(100%-1rem)] mb-2 ms-1 rounded-lg bg-amazone-beige-light"
      ></textarea>
    </div>
    <div class="text-right">
      <div class="flex flex-col gap-2">
        <button
          class="hover:bg-gray-100 hover:scale-120 cursor-pointer rounded-md"
          [ngClass]="iconColor"
          type="button"
          (click)="upsertHelpText()"
          appAgentAction
          agent="label-with-help-save"
          action="save"
        >
          <app-floppy-icon></app-floppy-icon>
        </button>
        <button
          class="hover:bg-gray-100 hover:scale-120 cursor-pointer rounded-md"
          [ngClass]="iconColor"
          type="button"
          (click)="cancelEditing()"
          appAgentAction
          agent="label-with-help-cancel"
          action="cancel"
        >
          <app-cancel-icon [size]="5"></app-cancel-icon>
        </button>
      </div>
    </div>
  }
</div>
